import React, {useState} from "react";

import {useQuery} from "react-query";

import {
    deleteIndicatorUser,
    getIndicatorsList,
    getIndicatorsListByUser,
    setIndicator
} from "services/Indicators.service";
import Pagination from "components/Pagination";

import {Tooltip} from "../../../../components/Tooltip";
import {TagsListEdit} from "../Tags";
import Steps from "../../../../components/Steps";
import {UsersEdit} from "components/UsersSelect";
import {swalQuestion} from "../../../../components/Swal";
import {setLog} from "../../../../services/Logs.service";
import {UsersList} from "../UsersList";
import {useNavigate} from "react-router";
import {ListContainer} from "../../styles";
import {createExcelFile, createIndividualExcelFile} from "../../excelGenerator";
import {Link} from "react-router-dom";
import {DuplicateIndicator} from "../DuplicateIndicator";
import {useUser} from "../../../../store/providers/app";
import {toast} from "react-toastify";
import {useTags} from "../../../../store/providers/tags";

export default function IndicatorsList({selected = '', status, language, searchText, selectedUser, yearReference}) {

    const navigate = useNavigate();
    const { user } = useUser()
    const { getTagsEn, getTagsLang } = useTags()

    const [indicators, setIndicators] = useState([]);
    const [paginate, setPaginate] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [ascOrder, setAscOrder] = useState('asc');
    const [fieldOrder, setFieldOrder] = useState('titulo')
    const [indicatorsDownload, setIndicatorsDownload] = useState([]);

    const q = selected ? selected?.title : searchText;

    const {isFetching} = useQuery(['indicators_list', q, status, currentPage, language, selectedUser, fieldOrder, ascOrder, yearReference],
        () => {
            if (selectedUser) {
                return getIndicatorsListByUser({
                    user_id: selectedUser,
                    paginate: true,
                    currentPage,
                    q,
                    language,
                    sortDirection: ascOrder,
                    sortBy: fieldOrder,
                    year_reference: yearReference
                })
            }
            return getIndicatorsList({
                status,
                currentPage,
                q,
                language,
                sortDirection: ascOrder,
                sortBy: fieldOrder,
                year_reference: yearReference
            })
        },
        {
            onSuccess: (res) => {
                setIndicators(res.data)
                setPaginate({
                    from: res.meta.from,
                    to: res.meta.to,
                    total: res.meta.total
                })

                getTagsEn()
                getTagsLang('pt-BR')
            },
            refetchOnWindowFocus: false,
            retry: 1
        })

    const handlePageClick = (event) => {
        setCurrentPage(event.selected + 1)
    };

    const updateIndicator = (userId, indicatorId) => {
        const updatedItems = [...indicators]
        const index = updatedItems.findIndex(item => item.id === indicatorId);

        updatedItems[index].users = updatedItems[index].users.filter(user => user.id !== userId)
        setIndicators(updatedItems)
    }


    const handleDeleteUser = async (userId, typeUser, username, indicatorId) => {
        swalQuestion(`Deseja remover o usuário <b>${username}</b> deste indicador?`)
            .then(async (r) => {
                if (r.isConfirmed) {
                    await deleteIndicatorUser(userId)
                    updateIndicator(userId, indicatorId)

                    const typeLabel = typeUser === 1 ? 'Líder ESG' : 'Respondente';

                    setLog({
                        'title': 'DELETE_RESPONSIBLE_INDICATOR',
                        'description': `Excluiu o ${typeLabel} ${username}`,
                        'username': user?.username,
                        'indicator_id': indicatorId,
                    })

                    return true
                }
                return false
            })
    }

    const handleToggleOrder = (order, field) => {
        setAscOrder(order);
        setFieldOrder(field)
    }

    const handleNavigateToEdit = (indicatorId) => {
        swalQuestion(`<b>Deseja sair desta página?</b>`)
            .then(async (r) => {
                if (r.isConfirmed) {
                    navigate(`/collect/indicator/edit/${indicatorId}`)

                }
            })
    }

    const handleCheckIndicatorsDownload = (e, indicator) => {
        if(e.target.checked) {
            setIndicatorsDownload([...indicatorsDownload, indicator])
            return
        }
        setIndicatorsDownload(indicatorsDownload.filter(indicatorDownload => indicatorDownload.id !== indicator.id))
    }

    const handleCheckAllDownload = (e) => {
        if(e.target.checked) {
            setIndicatorsDownload(indicators)
            return
        }
        setIndicatorsDownload([])
    }

    const handleDonwloadIndividualAll = () => {
        indicatorsDownload.map((indicator) => createIndividualExcelFile(indicator))
    }

    const updateIndicatorYear = (id, year) => {
        const updatedItems = [...indicators]
        const index = updatedItems.findIndex(item => item.id === id);

        updatedItems[index].year_reference = year
        setIndicators(updatedItems)
    }


    const handleupdateIndicatorYear = async (id, title, year) => {
        swalQuestion(`Deseja alterar o ano de referência deste indicador?`)
            .then(async (r) => {
                if (r.isConfirmed) {

                    await setIndicator(id, { year_reference: year }).then(() => {
                        toast.success('Ano de referência alterado com sucesso!')
                        updateIndicatorYear(id, year)
                    })

                    setLog({
                        'title': 'UPDATE_YEAR_REFERENCE_INDICATOR',
                        'description': `Alterou o ano de referencia para ${year} do indicador ${id} - ${title}`,
                        'username': user?.username,
                        'indicator_id': id,
                    })

                    return true
                }
                return false
            })
    }

    return (
        <ListContainer>
            <div className="card mt-4 border-0 shadow-sm overflow-hidden">
                <div className="card-header">

                    <div className="d-flex justify-content-between">
                        <div className="dropdown">
                            <button
                                className="btn btn-secondary btn-sm dropdown-toggle"
                                type="button"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                                disabled={indicatorsDownload.length === 0}
                            >
                                <i className="bi bi-cloud-download me-2 fs-6" /> Download em massa ({indicatorsDownload.length})
                            </button>
                            <ul className="dropdown-menu">
                                <li
                                    className="dropdown-item"
                                    role="button"
                                    onClick={() => createExcelFile(indicatorsDownload)}
                                >
                                    Agrupar indicadores
                                </li>
                                <li
                                    className="dropdown-item"
                                    role="button"
                                    onClick={() => handleDonwloadIndividualAll()}
                                >
                                    Arquivos separados
                                </li>
                            </ul>
                        </div>
                        <Link to="/collect/indicator/add" className="btn btn-sm btn-success">
                            <i className="bi bi-file-earmark-plus me-2 fs-6"/>
                            <span>Criar indicador</span>
                        </Link>
                    </div>
                </div>

                <div className="card-body p-0 table-responsive">

                    <table className="table align-middle mb-0 table-striped-columns">
                        <thead className="text-uppercase text-xs">
                        <tr>
                            <th>
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    value=""
                                    onChange={(e) => handleCheckAllDownload(e)}
                                />
                            </th>
                            <th/>
                            <th className="position-relative" style={{minWidth: "120px"}}>
                                Código
                                <span
                                    role="button"
                                    onClick={() => handleToggleOrder(ascOrder === 'asc'
                                        ? 'desc' : 'asc', 'codigo')}
                                    className="ps-4 position-absolute"
                                    style={{marginTop: "-2px", right: "1rem"}}
                                >
                             {fieldOrder === 'codigo' && ascOrder === 'asc'
                                 ?
                                 <i className={`bi bi-sort-alpha-down fs-6 ${fieldOrder === 'titulo' && 'opacity-50'}`}/>
                                 :
                                 <i className={`bi bi-sort-alpha-down-alt fs-6 ${fieldOrder === 'titulo' && 'opacity-50'}`}/>
                             }
                            </span>
                            </th>
                            <th className="position-relative">
                                Título

                                <span
                                    role="button"
                                    onClick={() => handleToggleOrder(ascOrder === 'asc' ? 'desc' : 'asc', 'titulo')}
                                    className="ms-2 position-absolute"
                                    style={{marginTop: "-2px", right: "1rem"}}
                                >
                             {fieldOrder === 'titulo' && ascOrder === 'asc'
                                 ?
                                 <i className={`bi bi-sort-alpha-down fs-6 ${fieldOrder === 'codigo' && 'opacity-50'}`}/>
                                 :
                                 <i className={`bi bi-sort-alpha-down-alt fs-6 ${fieldOrder === 'codigo' && 'opacity-50'}`}/>
                             }
                            </span>
                            </th>
                            <th className="text-center text-nowrap">Líder ESG</th>
                            <th className="text-center">Respondente</th>
                            <th className="text-center">Ano publicação</th>
                            <th className="text-center">Idioma</th>
                            <th className="text-end">Status</th>
                        </tr>
                        </thead>
                        <tbody>
                        {indicators.map((indicator, index) => {

                                let respondent = ''
                                let leader = ''

                                if (indicator.users?.length) {
                                    leader = indicator.users.filter(user => user?.type === 1)
                                    respondent = indicator.users.filter(user => user?.type === 2)
                                }

                                return (
                                    <React.Fragment key={indicator.id}>
                                        <tr className="text-sm">
                                            <td>
                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        value=""
                                                        onChange={(e) => handleCheckIndicatorsDownload(e, indicator)}
                                                        checked={indicatorsDownload.find(item => item.id === indicator.id)}
                                                    />
                                                </div>
                                            </td>
                                            <td width={10}>
                                                <div className="d-flex gap-1">
                                                    <Tooltip label="Edição rápida">
                                                        <button className="btn btn-primary btn-sm" type="button"
                                                                data-bs-toggle="collapse"
                                                                data-bs-target={`#collapse-${index}`}
                                                                aria-expanded="true" aria-controls={`collapse-${index}`}>
                                                            <i className="bi bi-pencil"/>
                                                        </button>
                                                    </Tooltip>
                                                    <Tooltip label="Editar">
                                                        <button className="btn btn-warning btn-sm" type="button"
                                                                onClick={() => handleNavigateToEdit(indicator.id)}>
                                                            <i className="bi bi-pencil-square"/>
                                                        </button>
                                                    </Tooltip>
                                                    <Tooltip label="Download">
                                                        <button className="btn btn-sm btn-secondary" type="button"
                                                                onClick={() => createIndividualExcelFile(indicator)}>
                                                            <i className="bi bi-file-earmark-excel"/>
                                                        </button>
                                                    </Tooltip>
                                                    <DuplicateIndicator indicatorId={indicator.id} code={indicator.codigo} />
                                                </div>
                                            </td>
                                            <td>{indicator.codigo}</td>
                                            <td>{indicator.titulo.length > 30 ?
                                                <Tooltip label={indicator.titulo}>
                                        <span>
                                            {indicator.titulo.slice(0, 30) + '...'}
                                        </span>
                                                </Tooltip>
                                                : indicator.titulo}

                                                {indicator.slug && indicator.status === "finished" &&
                                                    <div>
                                                        <a
                                                            href={`https://centraldesustentabilidade.suzano.com.br/indicadores/?ind=${indicator.slug}`}
                                                            target="_blank"
                                                            className="d-flex gap-1 align-items-center"
                                                        >
                                                            <i className="bi bi-link-45deg fs-5"/>
                                                            Ver indicador publicado
                                                        </a>
                                                    </div>
                                                }
                                            </td>
                                            <td>
                                                {leader.length > 0 &&
                                                    <UsersList
                                                        users={leader}
                                                        handleDeleteUser={handleDeleteUser}
                                                        indicatorId={indicator.id}
                                                        label="Líder ESG"
                                                    />
                                                }
                                            </td>
                                            <td>
                                                {respondent.length > 0 &&
                                                    <UsersList
                                                        users={respondent}
                                                        handleDeleteUser={handleDeleteUser}
                                                        indicatorId={indicator.id}
                                                        label="Respondentes"
                                                    />
                                                }
                                            </td>
                                            <td>
                                                <select className="form-select"
                                                    onChange={(e) => handleupdateIndicatorYear(indicator.id, indicator.titulo, e.target.value)}
                                                    value={indicator?.year_reference}
                                                >
                                                    <option value="">Selecione</option>
                                                    <option value="2021">2021</option>
                                                    <option value="2022">2022</option>
                                                    <option value="2023">2023</option>
                                                    <option value="2024">2024</option>
                                                    <option value="2025">2025</option>
                                                </select>
                                            </td>
                                            <td className="text-center">{indicator.language === 'pt-BR' ? 'Português' : 'Inglês'}</td>
                                            <td>
                                                <Steps
                                                    idDb={indicator.id}
                                                    statusIndicator={indicator.status}
                                                    showUsers={false}
                                                />
                                            </td>
                                        </tr>
                                        <tr className="border-top-0">
                                            <td colSpan={8} className="p-0">
                                                <div id={`collapse-${index}`} className="accordion-collapse collapse"
                                                     aria-labelledby="collapse" data-bs-parent={`#collapse-${index}`}>
                                                    <div className="accordion-body p-0">
                                                        <div className="bg-light p-3 border-bottom border-top">
                                                            <h5 className="mb-0 fs-6">Líder ESG/Repondentes</h5>
                                                        </div>

                                                        <div className="py-3 px-4">
                                                            <UsersEdit
                                                                indicatorId={indicator.id}
                                                                usersIndicator={indicator.users}
                                                            />
                                                        </div>

                                                        <div className="bg-light p-3 border-bottom border-top">
                                                            <h5 className="mb-0 fs-6">Tags</h5>
                                                        </div>

                                                        <div className="px-3 py-2">
                                                            <TagsListEdit indicatorId={indicator.id}
                                                                          tagsIndicator={indicator.tags}
                                                                          lang={indicator.language}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </React.Fragment>
                                )
                            }
                        )}
                        </tbody>
                    </table>
                </div>
                <div className="card-footer bg-white border-top-0">
                    <Pagination
                        isFetching={isFetching}
                        paginate={paginate}
                        handlePageClick={handlePageClick}
                    />
                </div>
            </div>
        </ListContainer>
    )
}
